<template>
  <div class="news_content">
    <div class="head">
      <div class="input a-c">
        <div class="flex a-c">
          <span style="width:70px;margin-left:24px">名称：</span>
          <a-input placeholder="请输入意见名称" />
        </div>
        <!-- <div  class="flex a-c">
          <span  style="width:70px;margin-left:24px">类型：</span>
          <a-input placeholder="请输入潮流名称" />
        </div> -->
      </div>
        <div class="flex a-c">
        <a-button  icon="reload" style="margin-right:10px">
          重置
        </a-button>
        <a-button type="primary" class="mr24" icon="search" >
          查询
        </a-button>
      </div>
    </div>
    <div class="all mt24">
      <div class="content">
        <div class="conten_head flex a-c j-s">
          <!-- 表格头部 -->
          <span class="fs16 ml24"><b>意见反馈</b></span>
          <a-button
            type="primary"
            icon="plus-circle"
            class="mr24"
            @click="goadd"
            >新建</a-button
          >
        </div>
        <div>
          <!-- 表格 -->
          <a-table
            class="mt24 ml24 mr24"
            :scroll="{ x: true }"
            :columns="columns"
            :data-source="tableData"
            :rowKey="(record) => record.id"
            :pagination="{
              current: position.pageNum,
              total,
              showSizeChanger: true,
              pageSizeOptions: ['1', '5', '10', '20'],
              buildOptionText: (pageSizeOptions) =>
                `${pageSizeOptions.value}条/页`,
              showQuickJumper: true,
              showTotal: (total) => `共 ${total} 条`,
              onShowSizeChange: onShowSizeChange,
              onChange: handleTableChange,
            }"
          >
            <span slot-scope="text, record, index" slot="num">
              {{
                (position.pageNum - 1) * position.pageSize + parseInt(index) + 1
              }}
            </span>
            <template slot-scope="text, record, index" slot="images">
              <img
                v-if="record.imgs.length"
                v-image-preview
                class="imgclass"
                :src="record.imgs"
              />
            </template>
            <template slot="action" slot-scope="item">
              <a href="javascript:;"> 详情 </a>
              <a-divider type="vertical" />
              <a href="javascript:;"> 编辑 </a>
              <a-divider type="vertical" />
              <a-popconfirm
                title="你确定删除这个潮流吗?"
                ok-text="确定"
                cancel-text="取消"
              >
                <span style="color: red"> 删除 </span>
              </a-popconfirm>
            </template>
          </a-table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getAction, putAction, postAction, deleteAction } from "../http/manage";
export default {
  name: "zc",
  data() {
    return {
      id: "",
      list: {},
      tableData: [],
      total: 0,
      position: {
        pageNum: 1,
        pageSize: 10,
      },

      url: {
        // 获取产品列表
        list: "/api/feedback/feedbackSelectPage",
      },
      columns: [
        {
          title: "序号",
          scopedSlots: { customRender: "num" },
        },
        {
          title: "联系人",
          dataIndex: "contact",
        },
        {
          title: "内容",
          dataIndex: "content",
        },
        {
          title: "照片",
          scopedSlots: { customRender: "images" },
        },

        {
          title: "创建时间",
          dataIndex: "createDate",
        },
        {
          title: "操作",
          scopedSlots: { customRender: "action" },
        },
      ],
    };
  },
  mounted() {
    this.getList(1);
  },
  methods: {
    goadd() {
      this.$router.push("Optionadd");
    },
    getList(val) {
      let data = {
        pageNum: val,
        pageSize: 10,
      };
      postAction(this.url.list, data)
        .then((res) => {
          console.log(res.data.data.list);
          this.tableData = res.data.data.list;
          this.pagination.total = res.data.data.totalRows;
          this.pagination.current = val;
        })
        .catch(() => {});
    },
    onShowSizeChange(current, pageSize) {
      console.log("onShowSizeChange", current, pageSize);
      // 当我们点击多少条每页的的时候触发的，要重新调用一下接口，并将参数传过去，来重新渲染一下
      this.position.pageNum = current;
      this.position.pageSize = pageSize;
      this.getList();
    },
    // 分页事件三部曲
    handleTableChange(current, filters) {
      this.position.pageNum = current;
      this.position.pageSize = filters;
      // 这是点击第几页的时候触发的，重新调用了一下接口，并将参数传过去
      console.log(current, filters);
      this.getList();
    },
  },
};
</script>
<style scpoed>
.fs16 {
  font-size: 16px;
}

.j-s {
  justify-content: space-between;
}
.a-c {
  align-items: center;
}
.flex {
  display: flex;
}
.news_content {
  padding: 15px 15px 15px 15px;
  background: #fff;
}
.ml24 {
  margin-left: 24px;
}
.mr24 {
  margin-right: 24px;
}
.mt24 {
  margin-top: 24px;
}
.all {
  /* border:1px solid red; */
  /* height: 500px; */
  background: #fff;
}
.imgclass {
  /* width: 129px; */
  width: 30px;
  /* height: 80px; */
  height: 30px;
}
.content {
  /* // width: 100%; */
  height: auto;
  /* // border:1px solid red; */
  margin-top: 16px;
  margin-left: 24px;
  margin-right: 24px;
  /* // margin-top: 1.111111vw; */
  background: #fff;
  border: 1px solid rgba(229, 236, 237, 1);
  border-radius: 10px;
  box-shadow: 0px 11px 14px -10px rgba(229, 236, 237, 1);
}
.conten_head {
  /* height: 64px; */
  height: 4.444444vw;
  /* // width: 100%; */
  border-bottom: 1px solid #e5eced;
  /* // border-bottom: 1px solid red; */
}
.head {
  /* height: 136px; */
  /* height: 9.444444vw; */
  margin-left:24px;
  margin-right:24px;
  display: flex;
  justify-content: space-between;
  height: 5.555556vw;
  width: auto;
  background: #ffffff;
  border: 1px solid rgba(229, 236, 237, 1);
  border-radius: 10px;
  box-shadow: 0px 11px 14px -10px rgba(229, 236, 237, 1);
}
.input{
  display: flex;
}
</style>